if (!customElements.get('woh-product-film')) {
  customElements.define('woh-product-film', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      button.addEventListener('click', () => video.play().catch(() => {button.hidden = false;}));
      video.addEventListener('play', () => {button.hidden = true;});
      video.addEventListener('pause', () => {button.hidden = false;});
    }
  });
}
